module.exports = __webpack_public_path__ + "static/20-10-8b58bb10141690d307bfb51c802af9c1.jpg";